import React, { useState, useEffect, Fragment } from "react";
import Accordion from "../Accordion/Accordion";
import Input from "../DataEntry/Input";
import { useUser } from "../../Api/newSockets.api";
import { savePathToLocalStorage } from "../../utils/helpers";

const UserProfile = () => {
  savePathToLocalStorage();
  const { updateUser, getUser, user: socketUser, connected } = useUser();
  const [user, setUser] = useState<any>(null);
  const [editMode, setEditMode] = useState(false);
  const [newData, setNewData] = useState({
    fullname: "",
    email: "",
  });

  const handleEdit = () => {
    setEditMode((currentValue) => !currentValue);
    if (!editMode && user) {
      setNewData({
        fullname: user.fullname || "",
        email: user.email || "",
      });
    }
  };

  const handleChange = (userInput: string, e: React.ChangeEvent<HTMLInputElement>) => {
    setNewData({
      ...newData,
      [e.target.name]: userInput,
    });
  };

  const handleSave = () => {
    updateUser(newData);
    setUser({ ...user, ...newData });
    setEditMode(false);
  };

  useEffect(() => {
    if (!connected) return;
    getUser()
      .then((response: any) => {
        setUser(response);
        setNewData({
          fullname: response?.fullname || "",
          email: response?.email || "",
        });
      })
      .catch(() => setUser(null));
  }, [connected]);

  // Also update from socket user data when available
  useEffect(() => {
    if (socketUser && !user) {
      setUser(socketUser);
      setNewData({
        fullname: socketUser?.fullname || "",
        email: socketUser?.email || "",
      });
    }
  }, [socketUser]);

  const organizationData = user?.organizations;

  return (
    <div className="profile-page">
      {user ? (
        <Accordion
          title="User"
          onEdit={handleEdit}
          onSave={handleSave}
        >
          <div className="user-list">
            {editMode ? (
              <Fragment>
                <div className="edit-user-list">
                  <p>Full Name:</p>
                  <span>
                    <Input
                      value={newData.fullname}
                      onChange={handleChange}
                      name="fullname"
                      className="edit-input"
                    />
                  </span>
                </div>
                <div className="edit-user-list">
                  <p>Email:</p>
                  <span>
                    <Input
                      value={newData.email}
                      onChange={handleChange}
                      name="email"
                      className="edit-input"
                    />
                  </span>
                </div>
              </Fragment>
            ) : (
              <Fragment>
                <p>
                  Full Name: <span>{user.fullname || "-"}</span>
                </p>
                <p>
                  Email: <span>{user.email || "-"}</span>
                </p>
              </Fragment>
            )}
          </div>
        </Accordion>
      ) : (
        <div style={{ padding: "2rem", color: "#6c757d" }}>Loading user data...</div>
      )}

      {organizationData && (
        <Accordion title="Organization">
          <div className="organization-list">
            <p>
              Name: <span>{organizationData.name || "-"}</span>
            </p>
            {organizationData.logoUrl && (
              <div className="organization-logo-container">
                <p>Logo: </p>
                <div className="logo-container">
                  <img
                    className="organization-logo"
                    src={organizationData.logoUrl}
                    alt="Organization logo"
                  />
                </div>
              </div>
            )}
          </div>
        </Accordion>
      )}
    </div>
  );
};

export default UserProfile;
